/**
 * Merges react-hook-form field props with runtime accent border/focus styles (Tailwind cannot JIT dynamic hex).
 */
export function authInputFocusProps(accent, hasError, fieldFromRegister) {
  if (hasError) {
    return fieldFromRegister;
  }
  const { onFocus: rfOnFocus, onBlur: rfOnBlur, ...rest } = fieldFromRegister;
  return {
    ...rest,
    onFocus: e => {
      if (typeof rfOnFocus === 'function') {
        rfOnFocus(e);
      }
      e.currentTarget.style.borderColor = accent;
      e.currentTarget.style.boxShadow = `0 0 0 2px ${accent}44`;
    },
    onBlur: e => {
      if (typeof rfOnBlur === 'function') {
        rfOnBlur(e);
      }
      e.currentTarget.style.borderColor = '';
      e.currentTarget.style.boxShadow = '';
    },
  };
}
